import { useCallback, useRef } from 'react';
import { Avatar, Heading, Text } from '@doist/reactist';
import { FaUserFriends, FaDoorOpen } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useClickAway } from 'react-use';
import { mutate } from 'swr';

import useCurrentUser from './hooks/useCurrentUser';
import config from './config';

function SidebarFlyout({ expanded, close }) {
    const ref = useRef(null);
    const currentUser = useCurrentUser();
    const navigate = useNavigate();
    useClickAway(ref, close);
    

    const preformLogout = useCallback(() => {
        fetch(`${config.apiUrl}/company`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: '',
                password: '',
            })
        })
        .then(response => response.json())
        .then(data => {
            mutate('authData');
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch call
            console.error("Error:", error);
        })
    }, []);

    return (
        <div className={`flyout ${expanded}`} ref={ref}>
            <div className='userFlex userPad'>
                <Avatar
                    exceptionallySetClassName="avatar"
                    size="xxl"
                    user={{
                        name: `${currentUser?.firstName} ${currentUser?.lastName}`,
                        email: currentUser?.email,
                    }}
                    avatarUrl={currentUser.avatar}
                    />
                <div className="textData">
                    <Heading level={6} size="smaller">{`${currentUser?.firstName} ${currentUser?.lastName}`}</Heading>
                    <Text size="caption" tone="secondary">{currentUser?.email}</Text>
                </div>
            </div>
            <div className="flyoutHeader"></div>

            <ul className="css-ewdv3l">
                <li className="ps-menuitem-root css-16jkw2k"><a className="ps-menu-button" data-testid="ps-menu-button-test-id" tabIndex="0" href="/accounts" onClick={(evt) => {
                    evt.preventDefault();
                    navigate(`/accounts`);
                    close();
                }}><span className="ps-menu-icon css-wx7wi4"><FaUserFriends /></span><span className="ps-menu-label css-12w9als">Accounts</span></a></li>
                <li className="ps-menuitem-root css-16jkw2k"><a className="ps-menu-button" data-testid="ps-menu-button-test-id" tabIndex="0" href="/" onClick={(evt) => {
                    evt.preventDefault();
                    preformLogout();
                    close();
                }}><span className="ps-menu-icon css-wx7wi4"><FaDoorOpen /></span><span className="ps-menu-label css-12w9als">Sign Out</span></a></li>
            </ul>
        </div>
    )
}

export default SidebarFlyout;